import { useState, useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useCart } from "../context/CartContext";
import customPagesApi from "../admincomponents/CustomPagesApi";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [customPages, setCustomPages] = useState([]);
  const { cartCount, openCart } = useCart();

  const location = useLocation();
  const navigate = useNavigate();
  const isHome = location.pathname === "/";


  useEffect(() => {
    let cancelled = false;
  
    customPagesApi
      .list()
      .then((pages) => {
        if (!cancelled) {
          setCustomPages(
            pages.filter((page) => page.status === "Published")
          );
        }
      })
      .catch(() => {
        if (!cancelled) setCustomPages([]);
      });
  
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    setIsLoggedIn(!!localStorage.getItem("token"));
  }, [location]);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setIsLoggedIn(false);
    navigate("/login");
  };

  return (
    <header
    className={`w-full z-20 flex items-center justify-between px-6 md:px-20 py-6 absolute top-0 left-0 ${
      isHome ? "bg-transparent" : "bg-gray-900"
    }`}
  >
     {!menuOpen && (
        <button
          className="md:hidden text-white z-50"
          onClick={() => setMenuOpen(true)}
        >
          <svg
            className="fill-current"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M3 13h18c0.552 0 1-0.448 1-1s-0.448-1-1-1h-18c-0.552 0-1 0.448-1 1s0.448 1 1 1zM3 7h18c0.552 0 1-0.448 1-1s-0.448-1-1-1h-18c-0.552 0-1 0.448-1 1s0.448 1 1 1zM3 19h18c0.552 0 1-0.448 1-1s-0.448-1-1-1h-18c-0.552 0-1 0.448-1 1s0.448 1 1 1z" />
          </svg>
        </button>
      )}
      <div className="h-12 w-12 md:h-20 md:w-20 rounded-full overflow-hidden flex items-center justify-center bg-teal-500 absolute left-1/2 -translate-x-1/2 md:static md:translate-x-0">
        <img
          src="./logo.png"
          alt="Futura Bio Labs"
          className="w-full h-full object-cover"
        />
      </div>

      <nav className="hidden md:flex items-center gap-10 text-gray-300 text-sm tracking-wide">
        <NavLink
          to="/"
          className="transition-all duration-300 ease hover:scale-125 hover:text-teal-400"
        >
          HOME
        </NavLink>
        <NavLink
          to="/shop"
          className="transition-all duration-300 ease hover:scale-125 hover:text-teal-400"
        >
          SHOP
        </NavLink>
        <NavLink
          to="/contact"
          className="transition-all duration-300 ease hover:scale-125 hover:text-teal-400"
        >
          CONTACT
        </NavLink>
        <NavLink
          to="/faq"
          className="transition-all duration-300 ease hover:scale-125 hover:text-teal-400"
        >
          FAQ
        </NavLink>

        {customPages.map((page) => (
  <NavLink
    key={page._id}
    to={`/${page.slug}`}
    className="transition-all duration-300 ease hover:scale-125 hover:text-teal-400"
  >
    {page.title.toUpperCase()}
  </NavLink>
))}
        {isLoggedIn && (
          <button
            onClick={handleLogout}
            className="transition-all duration-300 ease hover:scale-125 hover:text-teal-400"
          >
            LOGOUT
          </button>
        )}


{!isLoggedIn && (
          <button
            onClick={()=>{
              navigate('/login')
            }}
            className="transition-all duration-300 ease hover:scale-125 hover:text-teal-400"
          >
            LOGIN
          </button>
        )}
      </nav>

      <button onClick={openCart} className="relative text-white z-10">
        <svg
          data-icon="cart-1"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          className="fkcart-icon-checkout"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 2.71411C2 2.31972 2.31972 2 2.71411 2H3.34019C4.37842 2 4.97454 2.67566 5.31984 3.34917C5.55645 3.8107 5.72685 4.37375 5.86764 4.86133H20.5709C21.5186 4.86133 22.2035 5.7674 21.945 6.67914L19.809 14.2123C19.4606 15.4413 18.3384 16.2896 17.0609 16.2896H9.80665C8.51866 16.2896 7.39 15.4276 7.05095 14.185L6.13344 10.8225C6.12779 10.8073 6.12262 10.7917 6.11795 10.7758L4.64782 5.78023C4.59738 5.61449 4.55096 5.45386 4.50614 5.29878C4.36354 4.80529 4.23716 4.36794 4.04891 4.00075C3.82131 3.55681 3.61232 3.42822 3.34019 3.42822H2.71411C2.31972 3.42822 2 3.1085 2 2.71411ZM7.49529 10.3874L8.4288 13.8091C8.59832 14.4304 9.16266 14.8613 9.80665 14.8613H17.0609C17.6997 14.8613 18.2608 14.4372 18.435 13.8227L20.5709 6.28955H6.28975L7.49529 10.3874ZM12.0017 19.8577C12.0017 21.0408 11.0426 22 9.85941 22C8.67623 22 7.71708 21.0408 7.71708 19.8577C7.71708 18.6745 8.67623 17.7153 9.85941 17.7153C11.0426 17.7153 12.0017 18.6745 12.0017 19.8577ZM10.5735 19.8577C10.5735 19.4633 10.2538 19.1436 9.85941 19.1436C9.46502 19.1436 9.1453 19.4633 9.1453 19.8577C9.1453 20.2521 9.46502 20.5718 9.85941 20.5718C10.2538 20.5718 10.5735 20.2521 10.5735 19.8577ZM19.1429 19.8577C19.1429 21.0408 18.1837 22 17.0005 22C15.8173 22 14.8582 21.0408 14.8582 19.8577C14.8582 18.6745 15.8173 17.7153 17.0005 17.7153C18.1837 17.7153 19.1429 18.6745 19.1429 19.8577ZM17.7146 19.8577C17.7146 19.4633 17.3949 19.1436 17.0005 19.1436C16.6061 19.1436 16.2864 19.4633 16.2864 19.8577C16.2864 20.2521 16.6061 20.5718 17.0005 20.5718C17.3949 20.5718 17.7146 20.2521 17.7146 19.8577Z"
            fill="currentColor"
          />
        </svg>
        {cartCount > 0 && (
          <span className="absolute -top-2 -right-2 bg-teal-400 text-black text-[10px] leading-none rounded-full w-4 h-4 flex items-center justify-center">
            {cartCount}
          </span>
        )}
      </button>

      {/* Backdrop */}
      <div
        className={`md:hidden fixed inset-0 bg-black/60 z-30 transition-opacity duration-300 ease-in-out ${
          menuOpen ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
        }`}
        onClick={() => setMenuOpen(false)}
      />

      {/* Full-screen mobile nav sliding in from the left */}
      <nav
        className={`md:hidden fixed top-0 left-0 h-full w-full bg-gray-900 z-40 flex flex-col px-8 py-6 text-gray-200 text-base tracking-wide transition-transform duration-300 ease-in-out ${
          menuOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        <div className="flex items-center justify-between mb-10">
          <div className="h-12 w-12 rounded-full overflow-hidden flex items-center justify-center bg-teal-500">
            <img
              src="./logo.png"
              alt="Futura Bio Labs"
              className="w-full h-full object-cover"
            />
          </div>
          <button
            className="text-white"
            onClick={() => setMenuOpen(false)}
            aria-label="Close menu"
          >
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        <div className="flex flex-col gap-7">
          <NavLink
            to="/"
            className="hover:text-teal-400 transition-colors"
            onClick={() => setMenuOpen(false)}
          >
            HOME
          </NavLink>
          <NavLink
            to="/shop"
            className="hover:text-teal-400 transition-colors"
            onClick={() => setMenuOpen(false)}
          >
            SHOP
          </NavLink>
          <NavLink
            to="/contact"
            className="hover:text-teal-400 transition-colors"
            onClick={() => setMenuOpen(false)}
          >
            CONTACT
          </NavLink>
          <NavLink
            to="/faq"
            className="hover:text-teal-400 transition-colors"
            onClick={() => setMenuOpen(false)}
          >
            FAQ
          </NavLink>
          {isLoggedIn && (
            <button
              onClick={() => {
                handleLogout();
                setMenuOpen(false);
              }}
              className="text-left hover:text-teal-400 transition-colors"
            >
              LOGOUT
            </button>
          )}
          {!isLoggedIn && (
            <button
              onClick={() => {
                navigate('/login')
                setMenuOpen(false);
              }}
              className="text-left hover:text-teal-400 transition-colors"
            >
              LOGIN
            </button>
          )}
        </div>
      </nav>
    </header>
  );
}